import { useCallback } from "react";

// хук для редиректа на url, которые находятся не в зоне действия react-router
export function useRedirect() {
  const redirect = useCallback((href: string, target?: "_blank") => {
    const el = document.createElement("a");
    el.href = href;
    if (target) {
      el.target = target;
    }
    if (target === "_blank") {
      el.rel = "noopener noreferrer";
    }
    el.click();
    el.remove();
  }, []);

  return redirect;
}
